"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppRoutes = exports.MicrofrontendApp = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const client_1 = require("react-dom/client");
const App_1 = __importDefault(require("./App"));
const MicrofrontendApp_1 = require("./MicrofrontendApp");
Object.defineProperty(exports, "MicrofrontendApp", { enumerable: true, get: function () { return MicrofrontendApp_1.MicrofrontendApp; } });
const AppRoutes_1 = require("./AppRoutes");
Object.defineProperty(exports, "AppRoutes", { enumerable: true, get: function () { return AppRoutes_1.AppRoutes; } });
if (process.env.IS_STANDALONE === "true") {
    const root = (0, client_1.createRoot)(document.getElementById("root"));
    root.render((0, jsx_runtime_1.jsx)(App_1.default, {}));
}
